module.exports = __webpack_public_path__ + "static/media/Facebook.a08d8fde.svg";